
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'logDisplay'
})
export class LogDisplayPipe implements PipeTransform {

  transform(logs: any, args?: any): boolean {

    return logs.filter(log => {
//        return (log && log.type && (log.type =="program"));
        return (log && log.type);
      });
    }
}



// WEBPACK FOOTER //
// ./~/@c4/sysman/src/app/pipes/log-display.pipe.ts